import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=6f6a08c2&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"
import style0 from "./ClientEdit.vue?vue&type=style&index=0&id=6f6a08c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a08c2",
  null
  
)

export default component.exports